// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-2Raw2zR7","sider":"sider-19Sx6vgv","stock_box":"stock_box-c2FS0wiS clearfix","sider_list":"sider_list-38IO1RaP","title":"title-1HKGj4Rz"};